import './nav.scss';
import { OutboundLink } from 'react-ga';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";

import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import { IApplicationState } from '../../store';
import ZLButton from '../zl-button/zl-button';
import { Routes, navigateTo } from '../../helpers/routes';

const { Header } = Layout;

const Nav: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const logo = `/static/zerolatency-new.png`;
    const selectedLanguage = useSelector((state: IApplicationState) => state.intl.selectedLanguage);
    const globalWebsiteUrl = useSelector((state: IApplicationState) => state.appSettings.globalWebsiteUrl);
    const location = useLocation();
    const [isGlobalGift, setGlobalGift ] = useState(false);

    let trackers: string[] = ['zerolatency'];
    const bookNow = t('globalGiftVouchers.bookNow');

    //ensure outbound links to the global website respect the users language choice (provided the global website supports it)
    const globalWebsiteLink = `${globalWebsiteUrl}/${selectedLanguage.globalWebsiteLangCode || 'en'}`;

    useEffect(() => {
        if (location.pathname.includes(Routes.RegionalGiftVoucher)) {
            setGlobalGift(true);
        }
    },[location])

    return (
        <>
            <Header className="nav-container">
                <div className="nav">
                    <OutboundLink
                        eventLabel="Navigate to Main Site"
                        to={globalWebsiteLink}
                        target="_top"
                        title="Zero Latency Website"
                        trackerNames={trackers}
                        className="logo"
                    >
                        <img src={logo} alt="Zero Latency Free Roam Virtual Reality" />
                    </OutboundLink>
                    {isGlobalGift &&
                        <ZLButton
                            title="Book Now"
                            onClick={() => {
                                setGlobalGift(false);
                                dispatch(navigateTo(Routes.BookNow, null, undefined, { locale: selectedLanguage?.globalWebsiteLangCode || 'en' }));
                            }}
                            className="zl-outline-btn"
                            >
                            {bookNow}
                        </ZLButton>
                    }
                </div>
            </Header>
        </>
    );
};

export default Nav;
